import { Locales } from './locales';

export const FORMS_LOCALIZATION = {
  [Locales.ru]: {
    required: 'Поле обязательно для заполнения',
    email: 'Email введен неверно',
    emailTaken: 'Email уже зарегистрирован в системе',
    minlength: 'Должно быть больше {requiredLength} символов',
    min: 'Должно быть больше {min}',
    mismatch: 'Неверное подтверждение',
    time: 'Время введено неверно',
    emailExists: 'Email занят',
    invalidDate: 'Дата введена неверно',
    invalidPhone: 'Телефон введен неверно',
    pattern: 'Введены запрещенные символы',
    invalidUrl: 'Ссылка введена неверно',
    groupExist: 'Группа с таким названием уже есть'
  },
  [Locales.en]: {
    required: 'Field is required',
    email: 'Email is not valid',
    emailTaken: 'Email is already registered in the system',
    minlength: 'Must be greater than {requiredLength} characters',
    min: 'Must be more than {min}',
    mismatch: 'Incorrect confirmation',
    time: 'The time entered is incorrect.',
    emailExists: 'Email is already registered in the system',
    invalidDate: 'The date was entered incorrectly.',
    invalidPhone: 'The phone number entered is incorrect',
    pattern: 'Prohibited characters entered',
    invalidUrl: 'The link is entered incorrectly',
    groupExist: 'There is already a group with this name'
  },
};
